export const UPDATE_ADDRESS = 'UPDATE_ADDRESS'
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const REGISTER = 'REGISTER'
export const LOGIN = 'LOGIN'
export const SEND_EMAIL = 'SEND_EMAIL'
export const VERIFY_EMAIL = 'VERIFY_EMAIL'
export const RESEND_EMAIL = 'RESEND_EMAIL'
export const UPDATE_TAGS_COUNT = 'UPDATE_TAGS_COUNT'
// New append
export const CLEAR_TAGS_COUNT = 'CLEAR_TAGS_COUNT'
export const REGISTER_WHOLESALE_ACCOUNT = 'REGISTER_WHOLESALE_ACCOUNT'
export const SET_ERROR_STATE = 'SET_ERROR_STATE'
export const GET_ERRORS = 'GET_ERRORS'
export const LOGIN_AS = 'LOGIN_AS'
export const SET_WHOLESALE_PRICE_HIDDEN = 'SET_WHOLESALE_PRICE_HIDDEN'
export const SET_UI_PREFERENCE = 'SET_UI_PREFERENCE'
